// extracted by mini-css-extract-plugin
export default {"link":"style-module__link--WbvDi"};